import {memo} from 'react';
import {number} from 'prop-types';
import {styled, keyframes} from 'styled-components';
import {forbidExtraProps} from 'airbnb-prop-types';
import png from './spinner.png';

const spinnerAnimation = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
`;


const Spinner = styled.div`
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-image: url("${png}");
    animation: ${spinnerAnimation} .6s linear infinite;
  }
`;


export default memo(SpinnerCircle);

SpinnerCircle.propTypes = forbidExtraProps({
  size: number.isRequired,
});

function SpinnerCircle({
  size,
}) {
  return (
    <Spinner $size={size}/>
  );
}
